import React, { Component } from 'react';
import { connect } from 'react-redux';

import { BreadcrumbItem, Container, Row, Col } from 'reactstrap';

import GlobalSearchV2 from 'components/GlobalSearchV2';
import Bonuses from '../../../../components/Bonuses';
import { Link } from 'react-router-dom';
import BreadCrumbs from 'components/BreadCrumbs';

import ResourcesListTwo from 'routes/Products/components/ResourcesListTwo';
import RecipesList from '../../../../components/RecipesList/index';

const mapStateToProps = state => ({
  user: state.user
});

function RecipesPage(props) {
  const { user, product, hasCoaching, recipes, handleNav } = props;
  const productInPath = location.pathname.split('/')[2];

  const authToken = user && user.authToken;

  return (
    <div>
      {/* <BackNav /> */}
      <Container>
        <BreadCrumbs>
          <BreadcrumbItem tag={Link} to={`/products/${productInPath}`}>
            {product.title}
          </BreadcrumbItem>
          <BreadcrumbItem active tag="span">
            Recipes
          </BreadcrumbItem>
        </BreadCrumbs>
      </Container>

      <Container>
        {hasCoaching ? (
          <GlobalSearchV2 authToken={authToken} types={['recipe']} handleNav={handleNav} />
        ) : recipes && recipes.length ? (
          <RecipesList colSizes={{ xs: 12, md: 4 }} customTitle="All Recipes" Children={recipes} disableViewAll />
        ) : null}
      </Container>
    </div>
  );
}
export default connect(mapStateToProps)(RecipesPage);
